import React from 'react';
import PropTypes from 'prop-types';

// Components
import MobileItem from "components/WMS/Mobile/MobileItem";

// Local Components
import ShipmentCountBadge from "./ShipmentCountBadge";

// Assets
import {black500} from "assets/jss/main";
import {ReactComponent as ArrowRightIcon} from "assets/img/wms/arrow-right.svg";
import ColissimoIcon from "assets/img/carrier-icons/colissimo.svg";
import MondialRelayIcon from "assets/img/carrier-icons/mondial_relay.svg";

// Utils
import {ShippingMethodsDiscr} from "utils/ShippingMethods";

ShippingMethodItem.propTypes = {
    name: PropTypes.string.isRequired,
    discr: PropTypes.string.isRequired,
    shipmentCount: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired
};


function ShippingMethodItem({name,discr, shipmentCount, onClick}) {
    const iconSrc = getDiscriminatorIconSrc();


    function getDiscriminatorIconSrc() {
        switch (discr) {
            case ShippingMethodsDiscr.COLISSIMO:
                return ColissimoIcon
            case ShippingMethodsDiscr.MONDIAL_RELAY:
                return MondialRelayIcon
            default:
                return null;
        }
    }

    return (
        <MobileItem onClick={onClick}>
            <MobileItem.LeftSide>
                {iconSrc && (
                    <img
                        style={{
                            width: '16px',
                            height: '16px',
                            marginRight: '8px',
                        }}
                        src={iconSrc}
                    />
                )}
                <b style={{ fontSize: '14px', color: black500 }}>{name}</b>
            </MobileItem.LeftSide>
            <MobileItem.RightSide>
                <div style={{display: 'flex', gap: '16px'}}>
                    <ShipmentCountBadge count={shipmentCount} />
                    <ArrowRightIcon />
                </div>
            </MobileItem.RightSide>
        </MobileItem>
    );
}

export default ShippingMethodItem;
